import React, {Component} from 'react';
import {scroller} from "react-scroll";
import $ from 'jquery';
import {AJAX, hidePreloader, show_popup, showPreloader} from "../functions";
import RedirectOnlyHome from "../common/RedirectOnlyHome";
import {gTagClickEventValue} from "./frontend_script";
import EmailQuotePage from "./EmailQuotePage";
import TermsConditionsPopup from "./TermsConditionsPopup";
import {showPopupWithGoBack} from "../popups/PopupWithGoBack";

class BookingSummaryPage extends Component {
	constructor(props) {
		super(props);
		this.goBack = this.goBack.bind(this);
		this.goQuote = this.goQuote.bind(this);
		this.goBookingDetails = this.goBookingDetails.bind(this);
		this.handleTermsConditionsPopup = this.handleTermsConditionsPopup.bind(this);
		this.handleEmailQuote = this.handleEmailQuote.bind(this);
		this.sendError = this.sendError.bind(this);

		this.state = {
			showButtons: false,
			showQuote: false,
			to_show: this.props.to_show,
			signature_json: "{\"lines\":[]}",
			signature_png: '',
			terms_1: "0",
			terms_2: "0",
			terms_3: "0",
			terms_4: "0",
			terms_5: "0",
//			terms_6: "0",
			status: "",
			showError: false,
			total_round: 0
		};

//		console.log('BookingSummaryPage', this.props.booking_form_data);
	}

	handleTermsConditionsPopup(signature_json, signature_png, terms_1, terms_2, terms_3, terms_4, terms_5/*, terms_6*/, status) {
		this.setState({signature_json: signature_json, signature_png: signature_png, terms_1: terms_1, terms_2: terms_2, terms_3: terms_3, terms_4: terms_4, terms_5: terms_5/*, terms_6: terms_6*/, status: status});
//		console.log('handleTermsConditionsPopup', signature_json, signature_png, status);

		this.props.handleTermsConditions(signature_json, signature_png, terms_1, terms_2, terms_3, terms_4, terms_5/*, terms_6*/, status);
	}

	handleEmailQuote() {
		this.setState({showQuote: false, showButtons: true});
	}

	goBack() {
		this.setState({showButtons: false});
		if (this.props.booking_form_data.booking.hire === 'local')
			this.props.handleSetBookingSummary(false, true, true, true, false, true, this.props.get_total_result);
		else
			this.props.handleSetBookingSummary(false, true, true, false, true, true, this.props.get_total_result);

		let div = '';
		if (this.props.booking_form_data.booking.hire === 'local')
			div = 'id_search_form_local_div';
		else if (this.props.booking_form_data.booking.hire === 'interstate')
			div = 'id_search_form_interstate_div';

		this.props.handleSetSomeBlock('scroll_to_element', div);
	}

	goQuote() {
		this.setState({showButtons: false, showQuote: true});
	}

	goBookingDetails() {
		try {
			gTagClickEventValue((this.props.booking_form_data.booking.hire === 'local' ? 'click_to_confirm' : 'click_to_confirm_interstate'), {'event_category': 'booking', 'event_label': 'booking-confirm', 'value': parseInt(this.state.total_round, 10)});
		}
		catch (e) {
		}
		gTagClickEventValue('click', {'event_category': 'booking', 'event_label': 'booking-confirm', 'value': parseInt(this.state.total_round, 10)});

		show_popup(<TermsConditionsPopup
			to_show={this.state.to_show}
			booking_form_data={this.props.booking_form_data}
			goNext={()=>{
				this.setState({showButtons: false});
			}}
			handleTermsConditionsPopup={this.handleTermsConditionsPopup}
			TermsConditions={window.terms_conditions}
			handleSetSomeBlock={this.props.handleSetSomeBlock}
		/>, {auto_close: false});
	}

	setData() {
		if (this.props.get_total_result.error === undefined) {
			if (this.props.get_total_result.total_round !== undefined) {
				this.setState({total_round: this.props.get_total_result.total_round});

				try {
					gTagClickEventValue((this.props.booking_form_data.booking.hire === 'local' ? 'click_to_continue' : 'click_to_continue_interstate'),
						{
							'event_category': 'booking',
							'event_label': 'booking-continue',
							'value': parseInt(this.props.get_total_result.total_round, 10)
						}
					);
				}
				catch (e) {
				}
				gTagClickEventValue('click',
					{
						'event_category': 'booking',
						'event_label': 'booking-continue',
						'value': parseInt(this.props.get_total_result.total_round, 10)
					}
				);
			}

			if (this.props.get_total_result.html !== undefined) {
				$('#booking-result-table').html(this.props.get_total_result.html);
/*
				if (this.props.booking_form_data.booking.hire == 'local') {
					$('#booking-result-table').html(this.props.get_total_result.html);
				}
				else {
					const interstate_html=`
						<p style="text-align:right;"><img src="../../wp-content/plugins/booking-form/images/gecko-headset.png" alt="gecko headset" className="alignright"/></p>
						<h4>Thank you for your enquiry.</h4>
						<p style="font-size:18px;">
						  Our team is dilligently working on a best quote offer for you, and we’ll be in contact shortly with the details.  If you have an immediate concern, please contact our team on <a href="tel:1300826883">1300 826 883</a> for immediate service. Thank you!
						</p>
					`;
					$('#booking-result-table').html(interstate_html);
				}
*/
				this.setState({showButtons: true});
			}

			let to_show = this.props.to_show;

			if (this.props.booking_form_data.booking.hire == 'local') {

				if (this.props.get_total_result.allowance > 0)
					to_show.kms = this.props.get_total_result.allowance;

				if (this.props.get_total_result.selected_available.location != undefined)
					to_show.selected_location = this.props.get_total_result.selected_available.location;
				if (this.props.get_total_result.selected_available.car != undefined)
					to_show.selected_car = this.props.get_total_result.selected_available.car;
				if (this.props.get_total_result.selected_available.picture != undefined)
					to_show.truck_picture = {
						backgroundImage: `url(${this.props.get_total_result.selected_available.picture})`,
						maxWidth: "350px"
					};
				if (this.props.get_total_result.selected_available.pickup != undefined)
					to_show.selected_pickup = this.props.get_total_result.selected_available.pickup;
				if (this.props.get_total_result.selected_available.dropoff != undefined)
					to_show.selected_dropoff = this.props.get_total_result.selected_available.dropoff;
			} else if (this.props.booking_form_data.booking.hire == 'interstate') {
				if (this.props.get_total_result.allowance > 0) {
					if (this.props.get_total_result.booking_data != undefined)
						to_show.booking_form_data = this.props.get_total_result.booking_data;
				} else {
					showPopupWithGoBack('Distance cannot be calculated. Please try later or call to us.');
					//				document.location.reload();
				}
			}

			if (this.props.get_total_result.permitted_towing != undefined) {
				to_show.towing_surcharge = this.props.get_total_result.permitted_towing;
			}

			this.setState({to_show: to_show});
			this.props.handleSetShowData(to_show);
		}
		else
			this.setState({showError: true});
	}

	componentDidMount() {
		this.setData();
//		console.log('componentDidMount');
	}

	componentDidUpdate(previousProps) {
		if (this.props.scroll_to_element === 'id_booking_summary_page') {
			scroller.scrollTo(this.props.scroll_to_element, {
				duration: 800,
				smooth: true,
				offset: window.offset_scroll_value()
			});
			this.props.handleSetSomeBlock('scroll_to_element', '');
		}

		if (this.props.get_total_result.error === undefined && this.props.get_total_result.html !== undefined) {
			$('#booking-result-table').html(this.props.get_total_result.html);

			//console.log('hire 2 ' + this.props.booking_form_data.booking.hire);
			/*
			if (this.props.booking_form_data.booking.hire == 'local') {
				$('#booking-result-table').html(this.props.get_total_result.html);
			} else {
				const interstate_html = `
						<p style="text-align:right;"><img src="../../wp-content/plugins/booking-form/images/gecko-headset.png" alt="gecko headset" className="alignright"/></p>
						<h4>Thank you for your enquiry.</h4>
						<p style="font-size:18px;">
						  Our team is dilligently working on a best quote offer for you, and we’ll be in contact shortly with the details.  If you have an immediate concern, please contact our team on <a href="tel:1300826883">1300 826 883</a> for immediate service. Thank you!
						</p>
					`;
				$('#booking-result-table').html(interstate_html);
			}
			*/
		}
		else
			if (this.props.get_total_result.error !== undefined && previousProps.get_total_result.error !== this.props.get_total_result.error )
			this.setState({showError: true});
	}

	sendError(e) {
		let fields = this.props.booking_field_list.error_limit;
		let btn = e.target;
		let form_inputs = $(btn).closest('.totalerror');
		let params = {};
		let t = this;

		Object.keys(fields).map((item) => {
			let el = form_inputs.find('[name='+fields[item]+']');
			if (el.length) {
				params['booking['+fields[item]+']'] = el[0].value.trim();
			}
		});

		params.action = 'api/booking/totalerror';

		AJAX(bf_ajax_url, 'POST', params, {
			response_json: true,
			func_waiting: function () {
				showPreloader();
			},
			func_callback: function (resp) {
				if(resp.error !== undefined)
					showPopupWithGoBack(resp.error);
				else if(resp.data !== undefined)
					showPopupWithGoBack('<img src="../../wp-content/plugins/booking-form/images/thumb-up-gecko.png" alt="gecko" style={{float:"left",margin:"0px 20px 0px 0px"}}>Your request has been sent. Thank you for choosing to Go with the Gecko.');

//				console.log(resp);

				t.setState({showError: false});

				hidePreloader();
			},
			func_error: function (resp) {
				hidePreloader();
				showPopupWithGoBack(resp.message);
			}
		});
	}

	render() {

		return (<>
			<RedirectOnlyHome />

			<div id={'id_booking_summary_page'} className={'summary'} style={{}}>
				{
					(this.state.showError || this.props.get_total_result.html !== undefined) &&
					(
						<div className="col" id={'booking-result-table'}>
							<img src="../../wp-content/plugins/booking-form/images/gecko-headset.png"
								alt="gecko headset" className="alignleft"/>
							<p style={{color:"#d63545",fontSize:"18px"}}>
								<strong>Opps, our system seems to be busy?!</strong>
							</p>
							<p>
								Sorry about this. You can go back and try again or, leave your name and number and we'll call you back immediately to finalize!
							</p>
							<div className="col">
								<div className="row totalerror">
									<div className="form-group col-md-6 fake-placeholder">
										<div className="placeholder">
											<label htmlFor="totalerror_name">Name</label><span className="star">*</span>
										</div>
										<input className="form-control required" type="text" name="totalerror_name"/>
									</div>
									<div className="form-group col-md-6 fake-placeholder">
										<div className="placeholder">
											<label htmlFor="totalerror_phone">Phone</label><span className="star">*</span>
										</div>
										<input className="form-control required" type="text" name="totalerror_phone"/>
									</div>
								</div>
								<div className="row justify-content-center">
									<div className="form-group col-auto">
										<input type="button" className="btn btn-green" value="Send" onClick={this.sendError}/>
									</div>
								</div>
							</div>
						</div>
					)
				}
				{
					this.state.showButtons && /* this.props.booking_form_data.booking.hire == 'local' && */
					(
						<>
							<div className="row justify-content-center justify-content-md-center">
								<div className="col-auto col-md-auto">
									<input type="button" className="btn btn-green action-button bf-confirm next"
										   value="Confirm" onClick={this.goBookingDetails} />
								</div>
							</div>
							{
								!this.state.showQuote &&
								<div className="row justify-content-center justify-content-md-center">

									<div className="col-auto col-md-auto">
										<input type="button" className="btn btn-green bf-cancel" value="Adjust"
											   onClick={this.goBack} />
									</div>

									<div className="col-auto col-md-auto">
										<input type="button" className="btn btn-green bf-quote"
											   value="Quote" onClick={this.goQuote}/>
									</div>
								</div>
							}
						</>
					)
				}
				{
					false && this.state.showButtons && this.props.booking_form_data.booking.hire != 'local' &&
					(
						<>
								<div className="row justify-content-center justify-content-md-center">
									<div className="col-auto col-md-auto">
										<input type="button" className="btn btn-green bf-cancel" value="Adjust"
											   onClick={this.goBack} />
									</div>
								</div>
						</>
					)
				}
				{
					this.state.showQuote &&
						<EmailQuotePage
							booking_form_data={this.props.booking_form_data}
							send_quote={this.props.booking_field_list.send_quote}
							handleEmailQuote={this.handleEmailQuote}
							handleSetBookingFormData = {this.props.handleSetBookingFormData}
						/>
				}
			</div>
		</>);
	}
}

export default BookingSummaryPage;